const COFFEE_STEAM_CONFIG = {
  startRotatingAngle: 50,
  speed: 40,
  wind: {
    power: 0.6,
    airConditionerAngle: 90,
    windowAngle: 60,
    transitionDuration: 3000,
  },
}

export { COFFEE_STEAM_CONFIG };
